<template>
    <DxPopup :visible="visible" :show-title="true" :drag-enabled="true" :resize-enabled="false"
        :show-close-button="false" :close-on-outside-click="false" :width="680" :height="'auto'"
        @hiding="onPopupHiding" @hidden="emit('update:visible', false)">
        <template #title>
            <div class="popup-header">
                <div class="popup-header-main">
                    <span class="dx-icon dx-icon-add popup-header-icon" />
                    <div class="popup-header-texts">
                        <div class="popup-header-title">Comandă nouă</div>
                        <div class="popup-header-subtitle">{{ tipComandaDenumire || 'Selectați tipul comenzii' }}</div>
                    </div>
                </div>
                <span class="header-close" @click="requestClose">×</span>
            </div>
        </template>

        <DxToolbarItem widget="dxButton" toolbar="bottom" location="after"
            :options="{ text: isSaving ? 'Se salvează...' : 'Salvează și deschide', type: 'default', disabled: isSaving || selectedTipComandaLocal == null || !headerClientId || !headerAgentId || !headerExpCurierNume || (areContractRequired && !headerContractId), onClick: handleSave }" />
        <DxToolbarItem widget="dxButton" toolbar="bottom" location="after"
            :options="{ text: 'Anulează', stylingMode: 'outlined', onClick: requestClose }" />

        <template #content>
            <div class="popup-body">

                <!-- Tip Comandă -->
                <div class="form-group-card">
                    <div class="form-group-caption">Tip Comandă <span class="required-star">*</span></div>
                    <div class="form-group-content">
                        <div class="field">
                            <DxSelectBox v-model:value="selectedTipComandaLocal" :items="categoriesArray"
                                display-expr="Denumire" value-expr="TipComanda" :search-enabled="true"
                                :show-clear-button="true" placeholder="Selectați tipul comenzii..." />
                        </div>
                    </div>
                </div>

                <!-- Contract (obligatoriu dacă categoria are AreContract=true) -->
                <div v-if="areContractRequired" class="form-group-card">
                    <div class="form-group-caption">Contract <span class="required-star">*</span></div>
                    <div class="form-group-content">
                        <div class="field">
                            <DxSelectBox v-model:value="headerContractId" :data-source="dsContracte"
                                display-expr="Numar" value-expr="ID" :search-enabled="true"
                                :show-clear-button="true" placeholder="Selectați contractul..." />
                        </div>
                    </div>
                </div>

                <!-- Informații comandă -->
                <div class="form-group-card">
                    <div class="form-group-caption">Informații Comandă</div>
                    <div class="form-group-content">
                        <div class="fg g3">
                            <div class="field span2">
                                <label>{{ partenerLabel }} <span class="required-star">*</span></label>
                                <DxDropDownBox v-model:value="headerClientId" v-model:opened="isPartenerDropDownOpened"
                                    :data-source="dsClienti"
                                    :display-expr="partenerDisplayExpr" value-expr="ID" :show-clear-button="true"
                                    :disabled="selectedTipComandaLocal == null"
                                    :placeholder="partenerLabel ? 'Selectați ' + partenerLabel.toLowerCase() + '...' : 'Selectați tipul comenzii mai întâi...'"
                                    content-template="gridContent" :drop-down-options="{ width: 500, height: 400 }">
                                    <template #gridContent>
                                        <div class="dropdown-grid-container" style="height: 300px;">
                                            <DxDataGrid ref="clientGridRef" :data-source="dsClienti" :columns="['Nume', 'CUI']"
                                                :hover-state-enabled="true" :height="280" :remote-operations="true"
                                                @row-click="onPartenerRowClick">
                                                <DxScrolling mode="virtual" />
                                                <DxFilterRow :visible="true" />
                                                <DxPaging :enabled="true" :page-size="5" />
                                                <DxSearchPanel :visible="true" placeholder="Caută..." />
                                                <DxGridToolbar>
                                                    <DxGridToolbarItem location="after">
                                                        <DxButton icon="plus" type="success" height="25px" width="25px"
                                                            @click="onAddNewPartener" />
                                                    </DxGridToolbarItem>
                                                    <DxGridToolbarItem name="searchPanel" />
                                                </DxGridToolbar>
                                            </DxDataGrid>
                                        </div>
                                    </template>
                                </DxDropDownBox>
                            </div>
                            <div class="field">
                                <label>Agent <span class="required-star">*</span></label>
                                <DxSelectBox v-model:value="headerAgentId" :data-source="dsAgenti" display-expr="Nume"
                                    value-expr="Id" :search-enabled="true" search-expr="Nume"
                                    :show-clear-button="true" placeholder="Selectați agentul..." />
                            </div>
                            <div class="field">
                                <label>Data Comenzii</label>
                                <DxDateBox v-model:value="headerDataComenzii" display-format="dd.MM.yyyy"
                                    :show-clear-button="false" />
                            </div>
                            <div class="field">
                                <label>Valută</label>
                                <DxSelectBox v-model:value="headerValutaId" :data-source="dsValute"
                                    display-expr="Simbol" value-expr="Id" :show-clear-button="true"
                                    placeholder="Selectați valuta..." />
                            </div>
                            <div class="field">
                                <label>Termen Livrare</label>
                                <DxDateBox v-model:value="headerTermenLivrare" display-format="dd.MM.yyyy"
                                    :show-clear-button="true" />
                            </div>
                            <div class="field span3">
                                <label>Denumire</label>
                                <DxTextBox v-model:value="headerNume" :show-clear-button="true"
                                    placeholder="Denumirea comenzii..." />
                            </div>
                            <div class="field span3">
                                <label>Observații</label>
                                <DxTextBox v-model:value="headerObservatii" :show-clear-button="true"
                                    placeholder="Observații comandă..." />
                            </div>
                            <div v-if="partenerLabel === 'Client'" class="field span3 field-switch">
                                <DxSwitch v-model:value="headerLivrareDirectaFurnizor" />
                                <label class="switch-label">
                                    Livrare directă de la furnizor
                                    <span class="switch-hint">Furnizorul livrează marfa direct la client, fără să treacă prin gestiunea proprie — comanda poate fi pusă în lucru și facturată fără rezervare de stoc.</span>
                                </label>
                            </div>
                            <div class="field span3 field-checkbox-group">
                                <label>Livrat de <span class="required-star">*</span></label>
                                <div class="checkbox-row">
                                    <div v-for="opt in EXP_CURIER_OPTIONS" :key="opt" class="checkbox-item"
                                        :class="{ 'checkbox-item--active': headerExpCurierNume === (EXP_CURIER_LABELS[opt] || opt) }"
                                        @click="onToggleExpCurierTip(opt, headerExpCurierNume !== (EXP_CURIER_LABELS[opt] || opt))">
                                        <DxCheckBox class="checkbox-item-box"
                                            :value="headerExpCurierNume === (EXP_CURIER_LABELS[opt] || opt)" />
                                        <span>{{ EXP_CURIER_LABELS[opt] || opt }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </template>
    </DxPopup>

    <!-- Popup Adăugare Partener Nou -->
    <DxPopup :visible="isPartnerModalVisible" :width="1450" :height="684" :show-title="true"
        title="Adăugare Partener Nou" @hiding="isPartnerModalVisible = false">
        <template #title>
            <div class="popup-header">
                <div class="popup-header-main">
                    <span class="popup-header-icon dx-icon-add"></span>
                    <div class="popup-header-texts">
                        <div class="popup-header-title">Adăugare partener</div>
                        <div class="popup-header-subtitle">
                            Completează detaliile partenerului
                        </div>
                    </div>
                </div>
                <div class="popup-header-meta">
                    <span class="status-chip status-chip--draft">
                        Nou
                    </span>
                </div>
            </div>
        </template>
        <div class="popup-body-modern">
            <DxForm :form-data="newPartnerData" :col-count="3" :col-span="3">

                <DxFormItem item-type="group" caption="Identitate & Fiscal" :col-count="6"
                    css-class="form-section-simple form-section-card">
                    <DxFormItem data-field="CUI" :label="{ text: 'CUI/CNP' }" :editor-options="cuiOptions"
                        :col-span="3">
                        <DxRequiredRule message="Câmpul 'CUI/CNP' este obligatoriu" />
                    </DxFormItem>
                    <DxFormItem data-field="Nume" :col-span="3">
                        <DxRequiredRule message="Câmpul 'Nume' este obligatoriu" />
                    </DxFormItem>

                    <DxFormItem data-field="Fiscal" editor-type="dxSelectBox" :col-span="4"
                        :label="{ text: 'Tip Fiscal' }" :editor-options="{
                            dataSource: dsParteneriFiscal,
                            displayExpr: 'Nume',
                            valueExpr: 'Cod',
                            placeholder: 'Selectează Tip Fiscal',
                            searchEnabled: true,
                        }">
                        <DxRequiredRule message="Câmpul 'Tip Fiscal' este obligatoriu" />
                    </DxFormItem>
                    <DxFormItem data-field="Numar" :label="{ text: 'Regim Comerț' }" :col-span="2" />
                    <DxFormItem data-field="Caen" :label="{ text: 'Cod CAEN' }" :col-span="2" />

                    <DxFormItem data-field="Owner" :editor-options="{ readOnly: true }"
                        :label="{ text: 'Responsabil' }" :col-span="2" />
                    <DxFormItem data-field="Cont" :label="{ text: 'IBAN' }" :col-span="2" />

                    <DxFormItem data-field="GrupID" editor-type="dxSelectBox" :col-span="3"
                        :label="{ text: 'Grup *' }" :editor-options="{
                            dataSource: dsGrupuri,
                            displayExpr: 'Nume',
                            valueExpr: 'Id',
                            placeholder: 'Selectează grup',
                            searchEnabled: true,
                            showClearButton: true,
                        }" />
                    <DxFormItem data-field="ZonaID" editor-type="dxSelectBox" :col-span="3"
                        :label="{ text: 'Zona *' }" :editor-options="{
                            dataSource: dsZona,
                            displayExpr: 'Nume',
                            valueExpr: 'Id',
                            placeholder: 'Selectează zonă',
                            searchEnabled: true,
                            showClearButton: true,
                        }" />

                    <DxFormItem data-field="Memo" :col-span="6" :editor-options="{ height: 80 }"
                        editor-type="dxTextArea" />
                </DxFormItem>

                <DxFormItem item-type="group" caption="Sediu Social" :col-span="1" :col-count="4"
                    css-class="form-section-simple form-section-card">

                    <DxFormItem data-field="Strada" :col-span="3" />
                    <DxFormItem data-field="Numarstrada" :col-span="1" :label="{ text: 'Nr.' }" />

                    <DxFormItem data-field="Bloc" :col-span="1" />
                    <DxFormItem data-field="Scarabloc" :col-span="1" :label="{ text: 'Sc.' }" />
                    <DxFormItem data-field="Et" :col-span="1" :label="{ text: 'Etaj' }" />
                    <DxFormItem data-field="Ap" :col-span="1" :label="{ text: 'Ap.' }" />

                    <DxFormItem data-field="TaraID" template="taraTemplate" :col-span="2"
                        :label="{ text: 'Țara *' }" />
                    <DxFormItem data-field="JudetID" template="judetTemplate" :col-span="2"
                        :label="{ text: 'Județ *' }" />

                    <DxFormItem data-field="Localitate" :col-span="3" :label="{ text: 'Localitate' }"
                        :editor-options="{ onValueChanged: onLocalitateChanged }">
                        <DxRequiredRule message="Câmpul 'Localitate' este obligatoriu" />
                    </DxFormItem>
                    <DxFormItem data-field="CP" :col-span="1" :label="{ text: 'C.P.' }" />

                    <DxFormItem data-field="Adresa" :col-span="4" editor-type="dxTextArea"
                        :editor-options="{ height: 80 }" :label="{ text: 'Adresă Completă' }" />
                </DxFormItem>

                <DxFormItem item-type="group" caption="Domiciliu Fiscal" :col-span="1" :col-count="4"
                    css-class="form-section-simple form-section-card">
                    <DxFormItem data-field="CStrada" :col-span="3" :label="{ text: 'Strada' }" />
                    <DxFormItem data-field="CNumarstrada" :col-span="1" :label="{ text: 'Nr.' }" />

                    <DxFormItem data-field="CBloc" :col-span="1" :label="{ text: 'Bl.' }" />
                    <DxFormItem data-field="CScarabloc" :col-span="1" :label="{ text: 'Sc.' }" />
                    <DxFormItem data-field="CEt" :col-span="1" :label="{ text: 'Etaj' }" />
                    <DxFormItem data-field="CAp" :col-span="1" :label="{ text: 'Ap.' }" />

                    <DxFormItem data-field="CTaraID" template="cTaraTemplate" :col-span="2"
                        :label="{ text: 'Țara' }" />
                    <DxFormItem data-field="CJudetID" template="cJudetTemplate" :col-span="2"
                        :label="{ text: 'Județ' }" />

                    <DxFormItem data-field="CLocalitate" :col-span="3" :label="{ text: 'Localitate' }"
                        :editor-options="{ onValueChanged: onCLocalitateChanged }" />
                    <DxFormItem data-field="CCP" :col-span="1" :label="{ text: 'C.P.' }" />

                    <DxFormItem data-field="CAdresa" :col-span="4" editor-type="dxTextArea"
                        :editor-options="{ height: 80 }" :label="{ text: 'Adresă Completă' }" />
                </DxFormItem>

                <DxFormItem :col-count="3" :col-span="3">
                    <div class="show-more-container" style="display: flex; justify-content: center; margin: 1px 0;">
                        <DxButton :element-attr="{ class: 'show-more-btn' }"
                            :text="showExtendedDetails ? 'Ascunde detalii suplimentare' : 'Completează detalii suplimentare'"
                            :icon="showExtendedDetails ? 'chevronup' : 'chevrondown'" type="normal"
                            styling-mode="text" @click="showExtendedDetails = !showExtendedDetails" />
                    </div>
                </DxFormItem>

                <template #taraTemplate>
                    <DxDropDownBox v-model:value="sTaraID" v-model:opened="isTaraDropDownOpened"
                        :data-source="dsTari" display-expr="Nume" value-expr="ID"
                        :show-clear-button="true" placeholder="Selectează țara">
                        <template #content>
                            <DxDataGrid :data-source="dsTari" :selected-row-keys="sTaraID ? [sTaraID] : []"
                                :columns="['Nume']" :hover-state-enabled="true" height="100%"
                                :remote-operations="true" @selection-changed="onTaraSelectionChanged">
                                <DxSelection mode="single" />
                                <DxFilterRow :visible="true" />
                                <DxScrolling mode="virtual" />
                            </DxDataGrid>
                        </template>
                    </DxDropDownBox>
                </template>
                <template #judetTemplate>
                    <DxSelectBox v-model:value="newPartnerData.JudetID" :data-source="dsJudete" display-expr="Nume"
                        value-expr="ID" placeholder="Selectează județul" :search-enabled="true"
                        :show-clear-button="true" @value-changed="onJudetChanged" />
                </template>
                <template #cTaraTemplate>
                    <DxDropDownBox v-model:value="sCTaraID" v-model:opened="isCTaraDropDownOpened"
                        :data-source="dsCTari" display-expr="Nume" value-expr="ID"
                        :show-clear-button="true" placeholder="Selectează țara">
                        <template #content>
                            <DxDataGrid :data-source="dsCTari" :selected-row-keys="sCTaraID ? [sCTaraID] : []"
                                :columns="['Nume']" :hover-state-enabled="true" height="100%"
                                :remote-operations="true" @selection-changed="onCTaraSelectionChanged">
                                <DxSelection mode="single" />
                                <DxFilterRow :visible="true" />
                                <DxScrolling mode="virtual" />
                            </DxDataGrid>
                        </template>
                    </DxDropDownBox>
                </template>
                <template #cJudetTemplate>
                    <DxSelectBox v-model:value="newPartnerData.CJudetID" :data-source="dsCJudete" display-expr="Nume"
                        value-expr="ID" placeholder="Selectează județul" :search-enabled="true"
                        :show-clear-button="true" @value-changed="onCJudetChanged" />
                </template>
            </DxForm>

            <div v-show="showExtendedDetails">
                <DxForm :form-data="newPartnerData" :col-count="3" :col-span="3">
                    <DxFormItem item-type="group" caption="Configurare Financiară & Comercială"
                        css-class="form-section-simple form-section-card" :col-count="2">
                        <DxFormItem :label="{ text: 'Bancă (Internă)' }">
                            <DxDropDownBox v-model:value="sBanci" :data-source="dsBanci" display-expr="Nume"
                                value-expr="Id" :show-clear-button="true" placeholder="Selectează bancă"
                                content-template="gridContent" :drop-down-options="{ width: 200 }">
                                <template #gridContent>
                                    <div class="dropdown-grid-container" style="height: 300px;">
                                        <DxDataGrid :data-source="dsBanci" :columns="['Nume']"
                                            :hover-state-enabled="true" :height="280" :remote-operations="true"
                                            @row-click="onBanciRowClick">
                                            <DxPaging :enabled="true" :page-size="5" />
                                            <DxFilterRow :visible="true" />
                                            <DxScrolling mode="virtual" />
                                            <DxGridToolbar>
                                                <DxGridToolbarItem location="after">
                                                    <DxButton icon="plus" type="success" height="25px" width="25px"
                                                        @click="onAddNewBank" />
                                                </DxGridToolbarItem>
                                                <DxGridToolbarItem name="searchPanel" />
                                            </DxGridToolbar>
                                        </DxDataGrid>
                                    </div>
                                </template>
                            </DxDropDownBox>
                        </DxFormItem>

                        <DxFormItem :label="{ text: 'Valută' }">
                            <DxDropDownBox v-model:value="sValutaPartener" :data-source="valutaPartenerSelectat"
                                :show-clear-button="true" display-expr="Simbol" value-expr="Id" placeholder="RON">
                                <template #content>
                                    <DxDataGrid :data-source="dsValutaPartener"
                                        :selected-row-keys="sValutaPartener ? [sValutaPartener] : []"
                                        :columns="['Simbol']" :hover-state-enabled="true" height="100%"
                                        @selection-changed="onValutaPartenerSelectionChanged">
                                        <DxSelection mode="single" />
                                        <DxPaging :enabled="true" :page-size="5" />
                                        <DxFilterRow :visible="true" />
                                    </DxDataGrid>
                                </template>
                            </DxDropDownBox>
                        </DxFormItem>

                        <DxFormItem data-field="CapitalSocial" />
                        <DxFormItem data-field="CifraAfacere" />
                        <DxFormItem data-field="NrAngajati" :label="{ text: 'Nr. Angajati' }" />

                        <DxFormItem data-field="AdaosPret" :col-span="1" />
                        <DxFormItem data-field="Scadenta" :label="{ text: 'Termen de plată' }" :col-span="1"
                            :editor-options="{ readOnly: !canEditLimiteCredit }" />
                        <DxFormItem data-field="CreditLimita" :label="{ text: 'Limita de credit' }" :col-span="1"
                            :editor-options="{ readOnly: !canEditLimiteCredit }" />
                    </DxFormItem>

                    <DxFormItem item-type="group" caption="Contacte & Diverse"
                        css-class="form-section-simple form-section-card" :col-count="2">
                        <DxFormItem data-field="Tel" :label="{ text: 'Telefon' }" />
                        <DxFormItem data-field="Fax" />
                        <DxFormItem data-field="Email" />
                        <DxFormItem data-field="Director" />
                        <DxFormItem data-field="www" :label="{ text: 'Www' }" :col-span="2" />

                        <DxFormItem data-field="Observatii" :col-span="2" :editor-options="{ height: 100 }"
                            editor-type="dxTextArea" />
                    </DxFormItem>

                    <DxFormItem item-type="group" caption="System Flags"
                        css-class="form-section-simple form-section-card" :col-count="2">
                        <DxFormItem data-field="AplicaTVAlaIncasare" editor-type="dxCheckBox"
                            :label="{ text: 'TVA la Încasare' }" />
                        <DxFormItem data-field="RegimSpecialTVA" editor-type="dxCheckBox" />
                        <DxFormItem data-field="Intern" editor-type="dxCheckBox"
                            :editor-options="{ onValueChanged: handleInternChange }" />

                        <DxFormItem data-field="Extern" editor-type="dxCheckBox" :label="{ text: 'Extern Non UE' }"
                            :editor-options="{ onValueChanged: handleExternChange }" />

                        <DxFormItem data-field="ExternUE" editor-type="dxCheckBox" :label="{ text: 'Extern UE' }"
                            :editor-options="{ onValueChanged: handleExternUEChange }" />

                        <DxFormItem data-field="Client" editor-type="dxCheckBox" />
                        <DxFormItem data-field="Furnizor" editor-type="dxCheckBox" />
                        <DxFormItem data-field="Angajat" editor-type="dxCheckBox" />
                        <DxFormItem data-field="Activ" editor-type="dxCheckBox" />

                        <DxFormItem data-field="AplicaTvaDefalcat" editor-type="dxCheckBox"
                            :label="{ text: 'Split TVA' }" />
                        <DxFormItem data-field="faraScadenta" editor-type="dxCheckBox" />
                        <DxFormItem data-field="CalculezPenalitati" editor-type="dxCheckBox" />
                        <DxFormItem data-field="Litigiu" editor-type="dxCheckBox" />
                    </DxFormItem>
                </DxForm>
            </div>

            <div class="form-footer footer-modern">
                <div class="footer-right" style="margin-top: 1px; text-align: right;">
                    <DxButton text="Salvează Compania" type="success" @click="onSaveNewPartner" height="32px"
                        width="200px" styling-mode="outlined" :disabled="isSubmittingPartner" />
                    <DxButton text="Închide" @click="isPartnerModalVisible = false" height="32px" width="200px"
                        styling-mode="outlined" />
                </div>
            </div>
        </div>
    </DxPopup>

    <!-- Popup Adăugare Bancă -->
    <DxPopup :visible="isBankModalVisible" :width="800" :height="550" :show-title="true" title="Adăugare Bancă"
        @hiding="isBankModalVisible = false">
        <template #title>
            <div class="popup-header">
                <div class="popup-header-main">
                    <span class="popup-header-icon dx-icon-add"></span>
                    <div class="popup-header-texts">
                        <div class="popup-header-title">Adăugare bancă</div>
                        <div class="popup-header-subtitle">
                            Completează detaliile băncii
                        </div>
                    </div>
                </div>
                <div class="popup-header-meta">
                    <span class="status-chip status-chip--draft">
                        Nou
                    </span>
                </div>
            </div>
        </template>
        <div class="popup-body-modern">
            <DxForm :form-data="newBankData" :col-count="2" :col-span="2">
                <DxFormItem data-field="Ordine" />
                <DxFormItem data-field="Cod" />
                <DxFormItem data-field="Nume" />

                <DxFormItem :label="{ text: 'Valută' }">
                    <DxDropDownBox v-model:value="sValute" :data-source="dsValuteBanca" display-expr="Simbol"
                        value-expr="Id" :show-clear-button="true" placeholder="RON" content-template="gridContent">
                        <template #gridContent>
                            <div class="dropdown-grid-container" style="height: 300px;">
                                <DxDataGrid :data-source="dsValuteBanca" :columns="['Simbol']"
                                    :hover-state-enabled="true" :height="280" :remote-operations="true"
                                    @row-click="onValuteRowClick">
                                    <DxPaging :enabled="true" :page-size="5" />
                                    <DxFilterRow :visible="true" />
                                    <DxScrolling mode="virtual" />
                                </DxDataGrid>
                            </div>
                        </template>
                    </DxDropDownBox>
                </DxFormItem>
                <DxFormItem data-field="CodIban" />
                <DxFormItem data-field="CodBic" />
                <DxFormItem data-field="CodSwift" />
                <DxFormItem data-field="TextFc" />
                <DxFormItem data-field="Principala" editor-type="dxCheckBox" />
                <DxFormItem data-field="Activ" editor-type="dxCheckBox" />
            </DxForm>
            <div class="form-footer footer-fixed footer-modern">
                <div class="footer-right" style="margin-top: 10px; text-align: right;">
                    <DxButton text="Salvează Banca" type="success" @click="onSaveNewBank" height="32px"
                        width="200px" styling-mode="outlined" />
                    <DxButton text="Închide" @click="isBankModalVisible = false" height="32px" width="200px"
                        styling-mode="outlined" />
                </div>
            </div>
        </div>
    </DxPopup>
</template>

<script lang="ts" setup>
import { ref, shallowRef, computed, watch, onMounted } from 'vue';
import DxPopup, { DxToolbarItem } from 'devextreme-vue/popup';
import DxSelectBox from 'devextreme-vue/select-box';
import DxDateBox from 'devextreme-vue/date-box';
import DxTextBox from 'devextreme-vue/text-box';
import DxButton from 'devextreme-vue/button';
import DxSwitch from 'devextreme-vue/switch';
import DxCheckBox from 'devextreme-vue/check-box';
import DxDropDownBox from 'devextreme-vue/drop-down-box';
import DxForm, { DxItem as DxFormItem } from 'devextreme-vue/form';
import { DxRequiredRule } from 'devextreme-vue/validator';
import DxDataGrid, {
    DxFilterRow,
    DxPaging,
    DxScrolling,
    DxSearchPanel,
    DxSelection,
    DxToolbar as DxGridToolbar,
    DxItem as DxGridToolbarItem,
} from 'devextreme-vue/data-grid';
import DataSource from 'devextreme/data/data_source';
import ODataStore from 'devextreme/data/odata/store';
import AppSetting from '@/settings/appSettings';
import notify from 'devextreme/ui/notify';
import { custom } from 'devextreme/ui/dialog';
import ProComenziService from '@/services/Comercial/ProComenzi';
import PAR_Parteneri from '@/services/PAR/PAR_Parteneri';
import JwtServices from '@/services/JwtServices';
import AnafService from '@/services/AnafService';
import { useAddPartener } from '@/composable/useAddPartener';

interface Category {
    TipComanda: number;
    Denumire: string;
    TipFurnizor?: boolean | null;
    ValutaID?: string | null;
    AreContract?: boolean | null;
}

interface Props {
    visible: boolean;
    tipComanda?: number | null;
    comandaId?: string;
}

const props = defineProps<Props>();
const emit = defineEmits<{
    (e: 'update:visible', val: boolean): void;
    (e: 'saved', data: Record<string, any>): void;
}>();

const selectedTipComandaLocal = ref<number | null>(null);
const categoriesArray = ref<Category[]>([]);
const dsValute = ref<DataSource | null>(null);
const dsClienti = ref<DataSource | null>(null);
const dsAgenti = ref<DataSource | null>(null);
const dsContracte = ref<DataSource | null>(null);

const headerClientId = ref<string | null>(null);
const clientGridRef = ref<any>(null);
const isPartenerDropDownOpened = ref(false);
const headerAgentId = ref<string | null>(null);
const headerDataComenzii = ref<Date>(new Date());
const headerValutaId = ref<string | null>(null);
const headerTermenLivrare = ref<Date | null>(null);
const headerNume = ref<string>('');
const headerObservatii = ref<string>('');
const headerContractId = ref<string | null>(null);
const headerLivrareDirectaFurnizor = ref(false);
const headerExpCurierNume = ref<string>('');
const isSaving = ref(false);
const { idempotencyKey: comandaIdempotencyKey, resetIdempotencyKey: resetComandaIdempotencyKey } = useAddPartener();

const EXP_CURIER_OPTIONS = ['CURIER', 'SOFER', 'FURNIZOR', 'SEDIU', 'TEHNICIENI'];
const EXP_CURIER_LABELS: Record<string, string> = { SEDIU: 'RIDICARE DE LA SEDIU', TEHNICIENI: 'RIDICĂ TEHNICIENII' };

// Cele 4 bife se exclud reciproc — sursa unică de adevăr e chiar valoarea câmpului "Curier Nume"
// (fiecare bifă e "activă" doar dacă textul e egal cu eticheta ei); bifarea completează automat
// câmpul, dar acesta rămâne liber editabil ulterior (ex. numele exact al firmei de curierat).
function onToggleExpCurierTip(opt: string, checked: boolean) {
    const label = EXP_CURIER_LABELS[opt] || opt;
    if (checked) {
        headerExpCurierNume.value = label;
    } else if (headerExpCurierNume.value === label) {
        headerExpCurierNume.value = '';
    }
}

// ── Adăugare partener nou (dropdown + popup "Adaugă Partener") ──
const { isSubmitting: isSubmittingPartner, idempotencyKey: partnerIdempotencyKey, resetIdempotencyKey: resetPartnerIdempotencyKey } = useAddPartener();

const isPartnerModalVisible = ref(false);
const showExtendedDetails = ref(false);
const dsParteneriFiscal = ref<ODataStore | null>(null);
const dsBanci = ref<DataSource | null>(null);
const dsGrupuri = ref<DataSource | null>(null);
const dsZona = ref<DataSource | null>(null);
const dsTari = shallowRef<DataSource | null>(null);
const dsCTari = shallowRef<DataSource | null>(null);
const dsTariStore = ref<ODataStore | null>(null);
const dsCTariStore = ref<ODataStore | null>(null);
const dsGrupuriStore = ref<ODataStore | null>(null);
const dsJudete = shallowRef<DataSource | null>(null);
const dsCJudete = shallowRef<DataSource | null>(null);
const dsValutaPartener = ref<ODataStore | null>(null);
const valutaPartenerSelectat = ref<any[]>([]);
const sBanci = ref<string | null>(null);
const sValutaPartener = ref<string | null>(null);
const canEditLimiteCredit = ref(false);
const sTaraID = ref<string | null>(null);
const sCTaraID = ref<string | null>(null);
const isTaraDropDownOpened = ref(false);
const isCTaraDropDownOpened = ref(false);

function createEmptyPartnerData(): Record<string, any> {
    return {
        Nume: '', CUI: '', Cod: '', Fiscal: '', Numar: '', Strada: '', Localitate: '',
        JudetID: null, TaraID: null, ZonaID: null, Cont: '', Banca: '', Litigiu: false,
        Extern: false, Intern: true, Observatii: '', AdaosPret: null, faraScadenta: false,
        ValutaID: '0a61647e-7391-4087-bc01-8eb9c2cededd', Director: '', Fax: '', Tel: '',
        Email: '', www: '', GrupID: null, CP: '', CStrada: '', CLocalitate: '', CJudetID: null,
        CTaraID: null, CCP: '', Bloc: '', CBloc: '', Numarstrada: '', Scarabloc: '',
        CNumarstrada: '', CScarabloc: '', Scadenta: 0, AgentID: null, Angajat: false,
        Memo: '', CreditLimita: -1, DirectorEconomic: '', PersoanaContact: '',
        AplicaTVAlaIncasare: false, CifraAfacere: null, NrAngajati: null, Activ: true,
        Client: true, Furnizor: true, Owner: '', CalculezPenalitati: true,
        ParRecomandareID: null, CapitalSocial: null, AngajatID: null, ExternUE: false,
        StructuraLegaturaID: null, PartenerMasterID: null, RegimSpecialTVA: false,
        AplicaTvaDefalcat: false, Et: '', Ap: '', Adresa: '', CEt: '', CAp: '', CAdresa: '',
        CalculezPenalitatiDeLa: null, Prefix: '', Sufix: '', Caen: '', PunctID: null, ParentID: null,
    };
}

const newPartnerData = ref<Record<string, any>>(createEmptyPartnerData());

const isBankModalVisible = ref(false);
const dsValuteBanca = ref<DataSource | null>(null);
const sValute = ref<string | null>(null);
const newBankData = ref<Record<string, any>>({
    PartenerId: null, Cod: null, Nume: null, CodIban: null, CodBic: null,
    Principala: null, CodSwift: null, ValutaId: '0a61647e-7391-4087-bc01-8eb9c2cededd',
    Ordine: null, Activ: null, TextFc: null,
});

const cuiOptions = computed(() => ({
    placeholder: 'Introdu CUI',
    valueChangeEvent: 'keyup',
    onValueChanged: (e: any) => { newPartnerData.value.Cod = e.value; },
    onEnterKey: () => onSearchAnaf(),
    buttons: [{
        name: 'searchAnaf',
        location: 'after',
        options: {
            icon: 'search', width: 26, height: 26, type: 'default',
            hint: 'Caută în ANAF',
            onClick: () => onSearchAnaf(),
        },
    }],
}));

const tipComandaDenumire = computed<string>(() => {
    if (selectedTipComandaLocal.value == null) return '';
    return categoriesArray.value.find(c => c.TipComanda === selectedTipComandaLocal.value)?.Denumire ?? '';
});

const partenerLabel = computed<string>(() => {
    if (selectedTipComandaLocal.value == null) return 'Partener';
    const cat = categoriesArray.value.find(c => c.TipComanda === selectedTipComandaLocal.value);
    return cat?.TipFurnizor === true ? 'Furnizor' : 'Client';
});

const areContractRequired = computed<boolean>(() => {
    if (selectedTipComandaLocal.value == null) return false;
    const cat = categoriesArray.value.find(c => c.TipComanda === selectedTipComandaLocal.value);
    return cat?.AreContract === true;
});

function initDataSources() {
    const token = localStorage.getItem('ERA_Jwt') ?? '';
    const hdr = (e: any) => { e.headers = { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token }; };

    ProComenziService.getCategoriiPermise().then((resp: any) => {
        categoriesArray.value = (resp.data ?? []) as Category[];
    });
    dsContracte.value = new DataSource({
        store: new ODataStore({ url: AppSetting.API_Url_ComercialOdata + 'COM_Contracte', key: 'ID', keyType: 'Guid', version: 4, beforeSend: hdr }),
        select: ['ID', 'Numar', 'Denumire'],
        sort: [{ selector: 'Numar', desc: false }],
    });
    dsValute.value = new DataSource({
        store: new ODataStore({ url: AppSetting.API_Url_ComercialOdata + 'ERP_Valute', key: 'Id', keyType: 'Guid', version: 4, beforeSend: hdr }),
        select: ['Id', 'Simbol'],
        sort: [{ selector: 'Simbol', desc: false }],
    });
    dsAgenti.value = new DataSource({
        store: new ODataStore({ url: AppSetting.API_Url_ComercialOdata + 'COM_Agenti', key: 'Id', keyType: 'Guid', version: 4, beforeSend: hdr }),
        select: ['Id', 'Nume'],
        sort: [{ selector: 'Nume', desc: false }],
    });
}

function buildDsClienti(tipFurnizor: boolean | null | undefined) {
    const token = localStorage.getItem('ERA_Jwt') ?? '';
    const hdr = (e: any) => { e.headers = { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token }; };
    const filtru = tipFurnizor === true ? ['Furnizor', '=', true] : ['Client', '=', true];
    dsClienti.value = new DataSource({
        store: new ODataStore({ url: AppSetting.API_Url_ComercialOdata + 'PAR_Parteneri', key: 'ID', keyType: 'Guid', version: 4, beforeSend: hdr }),
        select: ['ID', 'Nume', 'CUI', 'ValutaID'],
        filter: filtru,
        sort: [{ selector: 'Nume', desc: false }],
    });
}

function partenerDisplayExpr(item: any): string {
    if (!item) return '';
    return item.CUI ? `${item.Nume} - ${item.CUI}` : item.Nume;
}

function onPartenerRowClick(e: any) {
    if (!e.data) return;
    headerClientId.value = e.data.ID;
    if (e.data.ValutaID) headerValutaId.value = e.data.ValutaID;
    isPartenerDropDownOpened.value = false;
}

function buildDsJudete(taraId: string | null | undefined) {
    const token = localStorage.getItem('ERA_Jwt') ?? '';
    const hdr = (e: any) => { e.headers = { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token }; };
    // Nomenclatorul ERP_Judete conține rânduri istorice fără Nume completat (doar Cod numeric,
    // orfane din import) — filtrate aici ca să nu apară goale în dropdown, fără a atinge datele.
    const filtruNumeCompletat = [['Nume', '<>', null], 'and', ['Nume', '<>', '']];
    const filtru = taraId ? [['TaraID', '=', taraId], 'and', filtruNumeCompletat] : filtruNumeCompletat;
    return new DataSource({
        store: { type: 'odata', url: AppSetting.API_Url_ComercialOdata + 'ERP_Judete', key: 'ID', keyType: 'Guid', version: 4, fieldTypes: { TaraID: 'Guid' }, beforeSend: hdr },
        select: ['ID', 'Nume'],
        filter: filtru,
        sort: [{ selector: 'Nume', desc: false }],
    });
}

function initPartnerDataSources() {
    const token = localStorage.getItem('ERA_Jwt') ?? '';
    const hdr = (e: any) => { e.headers = { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token }; };

    dsParteneriFiscal.value = new ODataStore({
        url: AppSetting.API_Url_ComercialOdata + 'PAR_ParteneriFiscal', key: 'ID', keyType: 'Guid', version: 4, beforeSend: hdr,
    });
    dsBanci.value = new DataSource({
        store: { type: 'odata', url: AppSetting.API_Url_ComercialOdata + 'PAR_BanciParteneri', key: 'Id', keyType: 'Guid', version: 4, beforeSend: hdr },
        select: ['Id', 'Nume'],
    });
    dsGrupuriStore.value = new ODataStore({
        url: AppSetting.API_Url_ComercialOdata + 'PAR_Grupuri', key: 'Id', keyType: 'Guid', version: 4, beforeSend: hdr,
    });
    dsGrupuri.value = new DataSource({
        store: dsGrupuriStore.value,
        select: ['Id', 'Nume', 'Cod'],
        sort: [{ selector: 'Cod', desc: false }],
    });
    dsZona.value = new DataSource({
        store: { type: 'odata', url: AppSetting.API_Url_ComercialOdata + 'ERP_Zone', key: 'Id', keyType: 'Guid', version: 4, beforeSend: hdr },
        select: ['Id', 'Nume'],
    });
    dsTariStore.value = new ODataStore({
        url: AppSetting.API_Url_ComercialOdata + 'ERP_Tari', key: 'ID', keyType: 'Guid', version: 4, beforeSend: hdr,
    });
    dsTari.value = new DataSource({
        store: dsTariStore.value,
        select: ['ID', 'Nume'],
        sort: [{ selector: 'Nume', desc: false }],
    });
    dsCTariStore.value = new ODataStore({
        url: AppSetting.API_Url_ComercialOdata + 'ERP_Tari', key: 'ID', keyType: 'Guid', version: 4, beforeSend: hdr,
    });
    dsCTari.value = new DataSource({
        store: dsCTariStore.value,
        select: ['ID', 'Nume'],
        sort: [{ selector: 'Nume', desc: false }],
    });
    dsJudete.value = buildDsJudete(newPartnerData.value.TaraID);
    dsCJudete.value = buildDsJudete(newPartnerData.value.CTaraID);
    dsValutaPartener.value = new ODataStore({
        url: AppSetting.API_Url_ComercialOdata + 'ERP_Valute', key: 'Id', keyType: 'Guid', version: 4, beforeSend: hdr,
    });
    dsValuteBanca.value = new DataSource({
        store: { type: 'odata', url: AppSetting.API_Url_ComercialOdata + 'ERP_Valute', key: 'Id', keyType: 'Guid', version: 4, beforeSend: hdr },
        select: ['Id', 'Simbol'],
    });
}

// Litere mici — trebuie să corespundă EXACT cu formatul în care .NET serializează Guid-ul
// (System.Guid.ToString() implicit e lowercase), altfel DxDropDownBox respinge intern
// potrivirea (comparație case-sensitive în DevExtreme) deși request-ul byKey reușește (200).
const ROMANIA_TARA_ID = 'd31c3594-8d39-4355-9a13-fd699a1b7290';
// "Romania" (fără diacritice) — corespunde exact valorii din ERP_Tari.Nume, ca să nu difere
// de textul pe care l-ar pune onTaraSelectionChanged la o reselectare manuală.
const ROMANIA_NUME = 'Romania';

function onAddNewPartener() {
    newPartnerData.value = {
        ...createEmptyPartnerData(),
        Owner: JwtServices.GetUsername(),
        TaraID: ROMANIA_TARA_ID,
        Adresa: ROMANIA_NUME,
    };
    sBanci.value = null;
    sValutaPartener.value = null;
    valutaPartenerSelectat.value = [];
    showExtendedDetails.value = false;
    resetPartnerIdempotencyKey();
    isPartnerModalVisible.value = true;

    dsJudete.value = buildDsJudete(newPartnerData.value.TaraID);
    dsCJudete.value = buildDsJudete(newPartnerData.value.CTaraID);
    sTaraID.value = newPartnerData.value.TaraID;
    sCTaraID.value = newPartnerData.value.CTaraID;
    ultimulJudetInAdresa = null;
    ultimulJudetInCAdresa = null;
    ultimaLocalitateInAdresa = null;
    ultimaCLocalitateInCAdresa = null;
}

// Tine minte ultimul nume de județ adăugat automat în Adresa/CAdresa, ca la schimbarea
// județului să-l putem elimina pe cel vechi înainte să adăugăm noul nume — altfel fiecare
// schimbare de județ se ADAUGĂ la infinit în câmpul de adresă (10 schimbări = 10 județe înșirate).
let ultimulJudetInAdresa: string | null = null;
let ultimulJudetInCAdresa: string | null = null;
let ultimaLocalitateInAdresa: string | null = null;
let ultimaCLocalitateInCAdresa: string | null = null;

function onTaraSelectionChanged(e: any) {
    if (!e.selectedRowKeys?.length) return;
    const id = e.selectedRowKeys[0];
    sTaraID.value = id;
    newPartnerData.value.JudetID = null;
    dsJudete.value = buildDsJudete(id);
    isTaraDropDownOpened.value = false;
    const taraNume = e.selectedRowsData?.[0]?.Nume;
    if (taraNume) newPartnerData.value.Adresa = taraNume;
    ultimulJudetInAdresa = null;
    ultimaLocalitateInAdresa = null;
}

function onCTaraSelectionChanged(e: any) {
    if (!e.selectedRowKeys?.length) return;
    const id = e.selectedRowKeys[0];
    sCTaraID.value = id;
    newPartnerData.value.CJudetID = null;
    dsCJudete.value = buildDsJudete(id);
    isCTaraDropDownOpened.value = false;
    const taraNume = e.selectedRowsData?.[0]?.Nume;
    if (taraNume) newPartnerData.value.CAdresa = taraNume;
    ultimulJudetInCAdresa = null;
    ultimaCLocalitateInCAdresa = null;
}

function aplicaJudetInAdresa(judetNume: string) {
    let current = (newPartnerData.value.Adresa || '').trim();
    if (ultimulJudetInAdresa) {
        current = current.replace(ultimulJudetInAdresa, '').replace(/,\s*,/g, ',').replace(/(^,\s*|,\s*$)/g, '').trim();
    }
    newPartnerData.value.Adresa = current ? `${current}, ${judetNume}` : judetNume;
    ultimulJudetInAdresa = judetNume;
}

function onJudetChanged(e: any) {
    const judetNume = e.component.option('selectedItem')?.Nume;
    if (!judetNume) return;
    aplicaJudetInAdresa(judetNume);
}

function aplicaLocalitateInAdresa(localitate: string) {
    let current = (newPartnerData.value.Adresa || '').trim();
    if (ultimaLocalitateInAdresa) {
        current = current.replace(ultimaLocalitateInAdresa, '').replace(/,\s*,/g, ',').replace(/(^,\s*|,\s*$)/g, '').trim();
    }
    newPartnerData.value.Adresa = localitate ? (current ? `${current}, ${localitate}` : localitate) : current;
    ultimaLocalitateInAdresa = localitate || null;
}

function onLocalitateChanged(e: any) {
    aplicaLocalitateInAdresa(String(e.value || '').trim());
}

// Normalizare diacritice + case pentru potrivirea numelui de județ primit de la ANAF
// (ex: "BIHOR") cu nomenclatorul ERP_Judete (ex: "Bihor"), fără sensibilitate la
// majuscule/diacritice (ANAF poate reveni cu sau fără diacritice, ex: "MURES"/"MUREȘ").
function normalizeazaText(text: string | null | undefined): string {
    return String(text ?? '')
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .toUpperCase()
        .trim();
}

async function cautaJudetDupaNume(nume: string | null | undefined, taraId: string | null): Promise<{ ID: string; Nume: string } | null> {
    if (!nume || !taraId) return null;
    const token = localStorage.getItem('ERA_Jwt') ?? '';
    const store = new ODataStore({
        url: AppSetting.API_Url_ComercialOdata + 'ERP_Judete', key: 'ID', keyType: 'Guid', version: 4,
        fieldTypes: { TaraID: 'Guid' },
        beforeSend: (e: any) => { e.headers = { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token }; },
    });
    const rows: any[] = await store.load({ filter: ['TaraID', '=', taraId], select: ['ID', 'Nume'] });
    const target = normalizeazaText(nume);
    return rows.find(j => normalizeazaText(j.Nume) === target) ?? null;
}

function onCJudetChanged(e: any) {
    const judetNume = e.component.option('selectedItem')?.Nume;
    if (!judetNume) return;
    let current = (newPartnerData.value.CAdresa || '').trim();
    if (ultimulJudetInCAdresa) {
        current = current.replace(ultimulJudetInCAdresa, '').replace(/,\s*,/g, ',').replace(/(^,\s*|,\s*$)/g, '').trim();
    }
    newPartnerData.value.CAdresa = current ? `${current}, ${judetNume}` : judetNume;
    ultimulJudetInCAdresa = judetNume;
}

function onCLocalitateChanged(e: any) {
    const localitate = String(e.value || '').trim();
    let current = (newPartnerData.value.CAdresa || '').trim();
    if (ultimaCLocalitateInCAdresa) {
        current = current.replace(ultimaCLocalitateInCAdresa, '').replace(/,\s*,/g, ',').replace(/(^,\s*|,\s*$)/g, '').trim();
    }
    newPartnerData.value.CAdresa = localitate ? (current ? `${current}, ${localitate}` : localitate) : current;
    ultimaCLocalitateInCAdresa = localitate || null;
}

function onSaveNewPartner() {
    if (!newPartnerData.value.Nume || String(newPartnerData.value.Nume).trim() === '') {
        notify('Completați câmpul obligatoriu "Nume"!', 'error', 1000);
        return;
    }
    if (!newPartnerData.value.Fiscal) {
        notify('Completați câmpul obligatoriu "Tip Fiscal"!', 'error', 1000);
        return;
    }
    if (!newPartnerData.value.TaraID) {
        notify('Completați câmpul obligatoriu "Țara"!', 'error', 1000);
        return;
    }
    if (!newPartnerData.value.JudetID) {
        notify('Completați câmpul obligatoriu "Județ"!', 'error', 1000);
        return;
    }
    if (!newPartnerData.value.Localitate || String(newPartnerData.value.Localitate).trim() === '') {
        notify('Completați câmpul obligatoriu "Localitate"!', 'error', 1000);
        return;
    }
    if (!newPartnerData.value.GrupID) {
        notify('Completați câmpul obligatoriu "Grup"!', 'error', 1000);
        return;
    }
    if (!newPartnerData.value.ZonaID) {
        notify('Completați câmpul obligatoriu "Zona"!', 'error', 1000);
        return;
    }

    isSubmittingPartner.value = true;
    PAR_Parteneri.save(newPartnerData.value, partnerIdempotencyKey.value).then((response: any) => {
        isSubmittingPartner.value = false;
        isPartnerModalVisible.value = false;
        notify('Datele au fost salvate cu succes!', 'success', 1000);

        const newId = response.data?.ID || response.data?.Id;
        if (newId) {
            headerClientId.value = newId;
            if (response.data.ValutaID) headerValutaId.value = response.data.ValutaID;
        }
        isPartenerDropDownOpened.value = false;
        dsClienti.value?.reload();
    }).catch((error: any) => {
        isSubmittingPartner.value = false;
        const status = error?.response?.status;
        const data = error?.response?.data;
        if (status === 409 && data?.code === 'CUI_EXISTS') {
            notify(data.message || 'Partenerul cu acest CUI există deja!', 'error', 2000);
            return;
        }
        notify('Eroare la salvarea partenerului.', 'error', 2000);
    });
}

function onBanciRowClick(e: any) {
    if (e.data) {
        sBanci.value = e.data.Id;
        newPartnerData.value.Banca = e.data.Nume;
    } else {
        sBanci.value = null;
        newPartnerData.value.Banca = '';
    }
}

function onAddNewBank() {
    newBankData.value = {
        PartenerId: null, Cod: null, Nume: null, CodIban: null, CodBic: null,
        Principala: null, CodSwift: null, ValutaId: '0a61647e-7391-4087-bc01-8eb9c2cededd',
        Ordine: null, Activ: null, TextFc: null,
    };
    sValute.value = '0a61647e-7391-4087-bc01-8eb9c2cededd';
    isBankModalVisible.value = true;
}

function onSaveNewBank() {
    if (!newBankData.value.Nume || String(newBankData.value.Nume).trim() === '') {
        notify('Completați câmpul obligatoriu "Nume"!', 'error', 1000);
        return;
    }

    const savedBankData = { ...newBankData.value };
    PAR_Parteneri.saveBank(newBankData.value).then((response: any) => {
        isBankModalVisible.value = false;
        notify('Datele au fost salvate cu succes!', 'success', 1000);

        const newId = response?.data?.ID || response?.data?.Id || response?.data?.id || response?.data;
        dsBanci.value?.reload().then(() => {
            if (newId) {
                sBanci.value = newId;
                newPartnerData.value.Banca = savedBankData.Nume;
            }
        });
    }).catch(() => {
        notify('Datele există deja sau a apărut o eroare!', 'error', 2000);
    });
}

// Litere mici — același motiv ca la ROMANIA_TARA_ID (comparație case-sensitive în DevExtreme
// față de Guid-ul lowercase serializat de .NET).
const GRUP_PERSOANA_FIZICA_ID = 'd41f9383-09b5-42c7-a33c-5050a438752a';
const GRUP_SMB_ID = '646a5caa-f34a-43ee-aebb-f1509b3e005e';

function onValutaPartenerSelectionChanged(e: any) {
    if (e.selectedRowKeys?.length > 0) {
        sValutaPartener.value = e.selectedRowKeys[0];
    } else {
        sValutaPartener.value = null;
    }
    newPartnerData.value.ValutaID = sValutaPartener.value;
}

function onValuteRowClick(e: any) {
    if (e.data) {
        sValute.value = e.data.Id;
        newBankData.value.ValutaId = e.data.Id;
    } else {
        sValute.value = null;
    }
}

function handleInternChange(e: any) {
    if (e.value) {
        newPartnerData.value.Extern = false;
        newPartnerData.value.ExternUE = false;
    }
}

function handleExternChange(e: any) {
    if (e.value) {
        newPartnerData.value.Intern = false;
        newPartnerData.value.ExternUE = false;
    }
}

function handleExternUEChange(e: any) {
    if (e.value) {
        newPartnerData.value.Intern = false;
        newPartnerData.value.Extern = false;
    }
}

async function onSearchAnaf() {
    const cuiRaw = newPartnerData.value.CUI;
    if (!cuiRaw) {
        notify('Te rog introdu un CUI valid', 'warning', 2000);
        return;
    }

    const cui = Number(String(cuiRaw).replace(/\D/g, ''));
    if (!cui) {
        notify('Te rog introdu un CUI valid', 'warning', 2000);
        return;
    }

    try {
        const anafResult = await AnafService.getCompanyDetails(cui);
        if (!anafResult) {
            notify('CUI-ul nu a fost găsit sau nu există date publice.', 'warning', 3000);
            return;
        }

        const dg = anafResult.date_generale;
        const ss = anafResult.adresa_sediu_social;
        const df = anafResult.adresa_domiciliu_fiscal;
        const formaOrg = String(dg?.forma_organizare ?? '').toUpperCase().trim();
        const scpTVA = Boolean(anafResult?.inregistrare_scop_Tva?.scpTVA);

        let fiscal = null;
        if (formaOrg.includes('PERSOANA FIZICA')) {
            fiscal = 'F';
        } else if (formaOrg.includes('PERSOANA JURIDICA')) {
            fiscal = scpTVA ? 'P' : 'N';
        }
        if (fiscal) newPartnerData.value.Fiscal = fiscal;

        // La fel ca în legacy (PAR_ParteneriForm.cs): CUI cu prefix "RO" doar dacă firma e
        // înregistrată ca plătitor de TVA la data căutării, altfel fără prefix.
        newPartnerData.value.CUI = scpTVA ? `RO${dg.cui}` : String(dg.cui);
        newPartnerData.value.Nume = dg.denumire ?? newPartnerData.value.Nume;
        newPartnerData.value.Numar = dg.nrRegCom ?? newPartnerData.value.Numar;
        newPartnerData.value.Caen = dg.cod_CAEN ?? newPartnerData.value.Caen;
        newPartnerData.value.CAdresa = dg.adresa ?? newPartnerData.value.CAdresa;
        newPartnerData.value.Localitate = ss.sdenumire_Localitate ?? newPartnerData.value.Localitate;
        newPartnerData.value.Strada = ss.sdenumire_Strada ?? newPartnerData.value.Strada;
        newPartnerData.value.Numarstrada = ss.snumar_Strada ?? newPartnerData.value.Numarstrada;
        newPartnerData.value.CP = ss.scod_Postal ?? newPartnerData.value.CP;
        newPartnerData.value.Tel = dg.telefon ?? newPartnerData.value.Tel;

        if (dg.iban) newPartnerData.value.Cont = dg.iban;
        newPartnerData.value.AplicaTVAlaIncasare = anafResult.inregistrare_RTVAI?.statusTvaIncasare ?? false;
        newPartnerData.value.AplicaTvaDefalcat = anafResult.inregistrare_SplitTVA?.statusSplitTVA ?? false;
        if (anafResult.stare_inactiv?.statusInactivi) {
            newPartnerData.value.Activ = false;
            notify('Atenție: firma este marcată ca INACTIVĂ la ANAF!', 'warning', 4000);
        }

        // Județ Sediu Social — ANAF întoarce doar numele (ex: "BIHOR"), nu ID-ul din
        // nomenclatorul intern ERP_Judete; se caută prin nume normalizat (fără diacritice/case).
        if (ss?.sdenumire_Judet) {
            const judet = await cautaJudetDupaNume(ss.sdenumire_Judet, newPartnerData.value.TaraID);
            if (judet) {
                newPartnerData.value.JudetID = judet.ID;
                aplicaJudetInAdresa(judet.Nume);
            } else {
                console.warn(`Județul „${ss.sdenumire_Judet}" (Sediu Social) nu a fost găsit în nomenclator — selectează-l manual.`);
            }
        }
        if (ss?.sdenumire_Localitate) aplicaLocalitateInAdresa(ss.sdenumire_Localitate);

        // Domiciliu Fiscal — completează și câmpurile structurate (CAdresa de mai sus rămâne
        // textul complet trimis direct de ANAF, nu se reconstruiește din bucăți).
        if (df) {
            newPartnerData.value.CLocalitate = df.ddenumire_Localitate ?? newPartnerData.value.CLocalitate;
            newPartnerData.value.CStrada = df.ddenumire_Strada ?? newPartnerData.value.CStrada;
            newPartnerData.value.CNumarstrada = df.dnumar_Strada ?? newPartnerData.value.CNumarstrada;
            newPartnerData.value.CCP = df.dcod_Postal ?? newPartnerData.value.CCP;
            if (df.ddenumire_Judet) {
                if (!newPartnerData.value.CTaraID) {
                    newPartnerData.value.CTaraID = newPartnerData.value.TaraID;
                    sCTaraID.value = newPartnerData.value.CTaraID;
                    dsCJudete.value = buildDsJudete(newPartnerData.value.CTaraID);
                }
                const cJudet = await cautaJudetDupaNume(df.ddenumire_Judet, newPartnerData.value.CTaraID);
                if (cJudet) {
                    newPartnerData.value.CJudetID = cJudet.ID;
                } else {
                    console.warn(`Județul „${df.ddenumire_Judet}" (Domiciliu Fiscal) nu a fost găsit în nomenclator — selectează-l manual.`);
                }
            }
        }

        const extras: string[] = [];
        if (dg.stare_inregistrare) extras.push(`Stare: ${dg.stare_inregistrare}`);
        if (typeof dg.statusRO_e_Factura === 'boolean') extras.push(`RO e-Factura: ${dg.statusRO_e_Factura ? 'DA' : 'NU'}`);

        try {
            let finData = await AnafService.getFinancialData(cui, 2024);
            if (!finData || !finData.i || finData.i.length === 0) {
                finData = await AnafService.getFinancialData(cui, 2023);
            }

            if (finData && finData.i) {
                const indicatori = finData.i;
                const caRow = indicatori.find((item: any) => {
                    const nume = item.val_den_indicator.toUpperCase();
                    return nume.includes('CIFRA DE AFACERI NET') || nume === 'VENITURI TOTALE';
                });
                const angRow = indicatori.find((item: any) => {
                    const nume = item.val_den_indicator.toUpperCase();
                    return nume.includes('NUMAR MEDIU DE SALARIATI') || nume.includes('NR. MEDIU SALARIATI');
                });

                if (caRow) {
                    newPartnerData.value.CifraAfacere = caRow.val_indicator;
                    extras.push(`CA: ${caRow.val_indicator.toLocaleString()}`);
                }
                if (angRow) {
                    newPartnerData.value.NrAngajati = angRow.val_indicator;
                    extras.push(`Angajați: ${angRow.val_indicator}`);
                }
            }
        } catch (finError) {
            console.warn('Datele financiare nu au putut fi încărcate.', finError);
        }

        if (extras.length) {
            const prev = newPartnerData.value.Memo ? String(newPartnerData.value.Memo).trim() + '\n' : '';
            newPartnerData.value.Memo = prev + extras.join(' | ');
        }

        notify('Datele au fost preluate cu succes!', 'success', 2000);
    } catch (error) {
        console.error(error);
        notify('Eroare la interogarea ANAF', 'error', 4000);
    }
}

async function loadCurrentAgent() {
    try {
        const res = await ProComenziService.getAgentCurent();
        headerAgentId.value = res.data?.AgentId ?? null;
    } catch {
        headerAgentId.value = null;
    }
}

async function handleSave() {
    isSaving.value = true;
    try {
        const resp = await ProComenziService.creeazaComanda({
            Tipcomanda: selectedTipComandaLocal.value,
            ClientId: headerClientId.value ?? null,
            AgentId: headerAgentId.value ?? null,
            DataComenzii: headerDataComenzii.value,
            ValutaId: headerValutaId.value ?? null,
            TermenLivrare: headerTermenLivrare.value ?? null,
            Nume: headerNume.value || null,
            Observatii: headerObservatii.value || null,
            ContractId: headerContractId.value ?? null,
            LivrareDirectaFurnizor: partenerLabel.value === 'Client' ? headerLivrareDirectaFurnizor.value : false,
            ExpCurierNume: headerExpCurierNume.value || null,
        }, comandaIdempotencyKey.value);
        resetComandaIdempotencyKey();
        emit('saved', resp.data);
        allowNextHide = true;
        emit('update:visible', false);
    } catch (err: any) {
        const raw = err?.response?.data;
        const msg = typeof raw === 'string' ? raw : (err?.message ?? 'Eroare la salvare.');
        notify(msg, 'error', 3000);
    } finally {
        isSaving.value = false;
    }
}

// Snapshot-ul câmpurilor imediat după deschidere (după reset + auto-completarea agentului
// curent) — comparat cu starea curentă la orice încercare de închidere, ca să deosebim
// "formular neatins" (închidere directă) de "userul a completat ceva" (cere confirmare).
// Nu se compară cu valori hardcodate (ex. "Tip Comandă gol") pentru că popup-ul poate porni
// cu tipul deja preselectat (props.tipComanda) sau cu agentul auto-completat — ambele sunt
// stare de deschidere legitimă, nu input de la user.
function currentFormSnapshot() {
    return JSON.stringify({
        tip: selectedTipComandaLocal.value,
        client: headerClientId.value,
        agent: headerAgentId.value,
        data: headerDataComenzii.value,
        valuta: headerValutaId.value,
        termen: headerTermenLivrare.value,
        nume: headerNume.value,
        obs: headerObservatii.value,
        contract: headerContractId.value,
        livrareDirecta: headerLivrareDirectaFurnizor.value,
        curierNume: headerExpCurierNume.value,
    });
}

const initialSnapshot = ref('');
const isFormDirty = computed(() => currentFormSnapshot() !== initialSnapshot.value);

// Setat true chiar înainte de un emit('update:visible', false) deja confirmat (salvare reușită
// sau confirmare explicită în requestClose) — altfel @hiding l-ar intercepta din nou pe
// închiderea provocată de acel emit, cerând confirmare de două ori / la nesfârșit.
let allowNextHide = false;

async function requestClose() {
    if (!isFormDirty.value) {
        allowNextHide = true;
        emit('update:visible', false);
        return;
    }
    const ok = await custom({
        title: 'Renunți la comanda nouă?',
        messageHtml: 'Ai completat date în formular. Dacă închizi acum, informațiile introduse se pierd.',
        buttons: [
            { text: 'Renunț la comandă', type: 'danger', onClick: () => true },
            { text: 'Rămân în formular', stylingMode: 'outlined', onClick: () => false },
        ],
    }).show();
    if (!ok) return;
    allowNextHide = true;
    emit('update:visible', false);
}

// Acoperă închiderile care nu trec prin butoanele proprii (× / Anulează) — ex. tasta Escape,
// care închide popup-ul DevExtreme direct, indiferent de close-on-outside-click=false.
function onPopupHiding(e: any) {
    if (allowNextHide) {
        allowNextHide = false;
        return;
    }
    e.cancel = true;
    requestClose();
}

onMounted(() => {
    initDataSources();
    initPartnerDataSources();
    PAR_Parteneri.getDrepturiMele()
        .then((res: any) => { canEditLimiteCredit.value = res.data?.EditareLimiteCredit === true; })
        .catch(() => { canEditLimiteCredit.value = false; });
});

watch(() => newPartnerData.value.Fiscal, (newVal) => {
    if (newVal === 'F') {
        newPartnerData.value.GrupID = GRUP_PERSOANA_FIZICA_ID;
    } else if (newVal === 'P' || newVal === 'N') {
        newPartnerData.value.GrupID = GRUP_SMB_ID;
    }
});

watch(sTaraID, (newId) => {
    newPartnerData.value.TaraID = newId;
});

watch(sCTaraID, (newId) => {
    newPartnerData.value.CTaraID = newId;
});

watch(sValutaPartener, (newId) => {
    if (newId && dsValutaPartener.value) {
        (dsValutaPartener.value as ODataStore).byKey(newId).then((x: any) => {
            x.Simbol = x.Simbol ?? '(fara simbol)';
            valutaPartenerSelectat.value = [x];
        });
    } else {
        valutaPartenerSelectat.value = [];
    }
});

watch(isPartenerDropDownOpened, (isOpened) => {
    if (isOpened) clientGridRef.value?.instance?.clearFilter();
});

watch(selectedTipComandaLocal, (tipComanda) => {
    headerClientId.value = null;
    if (tipComanda == null) {
        dsClienti.value = null;
        headerValutaId.value = null;
        return;
    }
    const cat = categoriesArray.value.find(c => c.TipComanda === tipComanda);
    buildDsClienti(cat?.TipFurnizor);
    headerValutaId.value = cat?.ValutaID ?? null;
});

watch(() => props.visible, async (isVisible) => {
    if (isVisible) {
        selectedTipComandaLocal.value = props.tipComanda ?? null;
        headerClientId.value = null;
        headerDataComenzii.value = new Date();
        headerValutaId.value = null;
        headerTermenLivrare.value = null;
        headerNume.value = '';
        headerObservatii.value = '';
        headerContractId.value = null;
        headerLivrareDirectaFurnizor.value = false;
        headerExpCurierNume.value = '';
        resetComandaIdempotencyKey();
        // Grid-ul de selecție client își păstrează textul din DxSearchPanel ȘI filtrele pe coloane
        // (Nume/CUI din DxFilterRow) — instanța rămâne montată cât timp DxPopup e doar ascuns, fără
        // reset explicit, o căutare/filtrare făcută la o comandă rămânea activă și la următoarea.
        clientGridRef.value?.instance?.clearFilter();
        await loadCurrentAgent();
        initialSnapshot.value = currentFormSnapshot();
    }
});
</script>

<style scoped>
:deep(.dx-popup-title.dx-toolbar) {
    padding: 0 !important;
    background: transparent !important;
    border-bottom: none !important;
    min-height: unset !important;
    height: auto !important;
}

:deep(.dx-popup-title .dx-toolbar-items-container) {
    height: auto !important;
}

:deep(.dx-popup-content) {
    padding: 0 !important;
}

.popup-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 18px;
    background: linear-gradient(90deg, #ff2c21, #ff6a4a);
    color: #fff;
}

.popup-header-main {
    display: flex;
    align-items: center;
    gap: 10px;
}

.popup-header-icon {
    font-size: 20px;
}

.popup-header-texts {
    display: flex;
    flex-direction: column;
}

.popup-header-title {
    font-size: 15px;
    font-weight: 700;
}

.popup-header-subtitle {
    font-size: 12px;
    opacity: 0.85;
}

.header-close {
    font-size: 22px;
    color: rgba(255, 255, 255, 0.8);
    cursor: pointer;
    line-height: 1;
    padding: 0 2px;
    transition: color 0.15s;
}

.header-close:hover {
    color: #fff;
}

.popup-body {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 12px 14px;
}

.form-group-card {
    border: 1px solid #e9ecef;
    border-radius: 4px;
    overflow: hidden;
    background: white;
}

.form-group-caption {
    background: #f8f9fa;
    color: #333;
    font-size: 14px;
    font-weight: 600;
    padding: 8px 14px;
    border-left: 3px solid #ff2c21;
}

.form-group-content {
    background: white;
    padding: 10px 14px;
}

.fg {
    display: grid;
    gap: 8px 12px;
}

.g3 {
    grid-template-columns: repeat(3, 1fr);
}

.g2 {
    grid-template-columns: repeat(2, 1fr);
}

.field {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.field label {
    font-weight: 500;
    color: #333;
    font-size: 13px;
}

.span2 {
    grid-column: span 2;
}

.span3 {
    grid-column: span 3;
}

.field-switch {
    flex-direction: row;
    align-items: flex-start;
    gap: 10px;
}

.field-checkbox-group .checkbox-row {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 8px 10px;
}

.checkbox-item {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
    padding: 6px 14px;
    border-radius: 20px;
    border: 1px solid #e5e7eb;
    background: #f8f9fc;
    cursor: pointer;
    transition: background 0.15s, border-color 0.15s, color 0.15s;
}

.checkbox-item-box {
    pointer-events: none;
}

.checkbox-item span {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #64748b;
}

.checkbox-item--active {
    background: linear-gradient(90deg, #ff2c21, #ff6a4a);
    border-color: transparent;
}

.checkbox-item--active span {
    color: #fff;
}

.switch-label {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.switch-hint {
    font-weight: 400;
    font-size: 11px;
    color: #888;
}

.required-star {
    color: #ff2c21;
}

/* ── Popup-uri Adaugă Partener / Adaugă Bancă (pattern CRM) ── */
.popup-header-meta {
    display: flex;
    align-items: center;
}

.status-chip {
    padding: 4px 10px;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 600;
    border: 1px solid rgba(255, 255, 255, 0.7);
}

.status-chip--draft {
    background-color: rgba(255, 255, 255, 0.18);
}

.footer-modern {
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.02);
}

:deep(.form-section-simple .dx-form-group-caption) {
    background: #f8f9fa;
    color: #333;
    font-size: 14px;
    font-weight: 600;
    padding: 10px 15px;
    margin: 15px 0 10px 0;
    border-left: 3px solid #ff2c21;
    border-radius: 0;
}

:deep(.form-section-simple .dx-form-group-content) {
    background: white;
    padding: 15px 0;
    margin-bottom: 10px;
}

.form-footer {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
}

.footer-right .dx-button {
    margin-left: 8px;
}

:deep(.show-more-btn .dx-button-text) {
    white-space: normal !important;
}

:deep(.show-more-btn .dx-button-content) {
    white-space: normal !important;
    flex-wrap: wrap;
}

:deep(.show-more-btn) {
    height: 25px;
    width: 400px;
}

.popup-body-modern {
    padding: 14px 18px 56px 18px;
}

.footer-fixed {
    position: sticky;
    bottom: 0;
    padding: 10px 16px;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    z-index: 10;
}

.dropdown-grid-container {
    height: 300px;
}
</style>
